export default __webpack_public_path__ + "static/media/PDFINVOICE.745db2d5.jpg";